import React, { useContext, useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material";
import { ThemeContext } from "../../../context/ThemeContext";
import { acceptApi, rejectApi } from "../../../api/request/dashboard/dashboard";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { hidePriceChangeDialog } from "../../../store/Slices/priceChange";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

const AcceptReject = () => {
    const { darkMode } = useContext(ThemeContext)
    const dispatch = useDispatch()
    const { showDialog, data } = useSelector(state => state.priceChange, shallowEqual);
    const { accountId } = useSelector(state => state.accountSummary, shallowEqual);
    const orders = useSelector((state) => state.orderPosition.orders, shallowEqual);
    const matchingOrder = orders.find(order => order.id === data?.orderId);
    const { UserCompleteDetails } = useSelector(state => state.user);
    const reQuoteTimeoutDuration = UserCompleteDetails?.reQuoteTimeoutDuration
    const [expired, setExpired] = useState(false);
    const timerRef = useRef(null);
    const { t } = useTranslation()
    const handleAccept = async () => {
        try {
            const payload = {
                id: data?.orderId,
                accountId: accountId,
            };
            await acceptApi(payload);
            dispatch(hidePriceChangeDialog());
            toast.success("Order Accepted Successfully!");
        } catch (err) {
            toast.error("Failed to Accept the Order.");
            console.error("Accept failed", err);
        }
    };

    const handleReject = async () => {
        try {
            await rejectApi(data);
            dispatch(hidePriceChangeDialog());
            toast.success("Order Rejected Successfully!");
        } catch (err) {
            toast.error("Failed to Reject the Order.");
            console.error("Reject failed", err);
        }
    };
    useEffect(() => {
        if (showDialog && reQuoteTimeoutDuration) {
            const [hours, minutes, seconds] = reQuoteTimeoutDuration.split(":").map(Number);
            const timeoutMs = (hours * 3600 + minutes * 60 + seconds) * 1000;

            timerRef.current = setTimeout(() => {
                setExpired(true);
            }, timeoutMs);
        }

        return () => clearTimeout(timerRef.current);
    }, [showDialog, reQuoteTimeoutDuration]);

    const handleClose = () => {
        dispatch(hidePriceChangeDialog());
    };

    if (!data) return null;

    return (
        <Dialog open={showDialog} onClose={() => dispatch(hidePriceChangeDialog())} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 0, boxShadow: 3, overflow: "hidden", }, }}>
            <Box sx={{ bgcolor: 'var(--primary)', color: 'var(--White)', display: "flex", alignItems: "center", gap: 1, px: 2, py: 1, }}>
                <Typography variant="body1" color="white" fontWeight={600}>{matchingOrder?.side === 1 ? "Buy" : "Sell"} {t("amount")} {matchingOrder?.amount} #{matchingOrder?.symbolName} {t("at")} {t("price")} {matchingOrder?.price}</Typography>
            </Box>

            <DialogContent sx={{ bgcolor: darkMode ? "var(--background-color)" : 'var(--white)' }}>
                <Box display='flex' justifyContent='center' alignItems="center" flexDirection='column' >
                    {expired ? (
                        <>
                            <Typography variant="subtitle2" color="text.secondary">{t('tradeText')}</Typography>
                        </>
                    ) : (
                        <>
                            <Typography variant="subtitle2" color="text.secondary">{t('newPrice')}</Typography>
                            <Typography variant="h4" color="error" fontWeight={700}>{data?.newPrice}</Typography>
                        </>
                    )}
                </Box>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center", pb: 2, bgcolor: darkMode ? "var(--background-color)" : 'var(--white)' }}>
                {expired ? (
                    <Button onClick={handleClose} variant="outlined" color="primary" sx={{ minWidth: 120, fontWeight: 600 }}>{t('close')}</Button>
                ) : (
                    <>
                        <Button onClick={handleAccept} variant="outlined" color="primary" sx={{ minWidth: 120, fontWeight: 600 }}>{t("accept")}</Button>
                        <Button onClick={handleReject} variant="outlined" color="error" sx={{ minWidth: 120, fontWeight: 600 }}>{t("reject")}</Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default AcceptReject;
